export const paths = ['/projects/:projectId/mailbox'];
